import React, { useEffect, useState } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import { LondonDate, formatDate, validateForm } from "../../Utils/utils";
import ApiService from "../../Core/Service/ApiService";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCheckbox, MDBIcon } from "mdb-react-ui-kit";
import { CmsType, CmsTypeStr } from "../../Constants/constants";
import AdminTable from "../../Components/AdminTable/AdminTable";
import BulkActionPanel, { BulkActions } from "../../Components/CMS/BulkActionPanel";
import Paginator from "../../Components/Paginator/Paginator";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";

const ExpirePreview = React.memo(props => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [bulkActioning, setBulkActioning] = useState(false);
    const perPageOptions = [
        {value: 10, label: '10'},
        {value: 20, label: '20'},
        {value: 50, label: '50'},
        {value: 100, label: '100'},
    ]
    const [formData, setFormData] = useState({
        pageNum: 1,
        perPage: 10,
        search: {
            end_date: {op: '<', value: LondonDate(new Date())},
            type: {op: '=', value: ''},
        },
        sort: {
            name: 'type',
            dir: 'ASC'
        }
    });
    const cmsTypeOptions = [
        {value: '', label: 'All'},
        {value: CmsType.Top_Ribbon, label: CmsTypeStr[CmsType.Top_Ribbon]},
        {value: CmsType.Home_Banner, label: CmsTypeStr[CmsType.Home_Banner]},
        {value: CmsType.Category_Banner, label: CmsTypeStr[CmsType.Category_Banner]},
        {value: CmsType.Products_Carousel, label: CmsTypeStr[CmsType.Products_Carousel]},
        {value: CmsType.Brochure, label: CmsTypeStr[CmsType.Brochure]},
        {value: CmsType.Bottom_Banner, label: CmsTypeStr[CmsType.Bottom_Banner]},
        {value: CmsType.Brand, label: CmsTypeStr[CmsType.Brand]},
    ];
    const [total, setTotal] = useState(0);
    const [rows, setRows] = useState([]);

    const getRows = async () => {
        setLoading(true);

        const data = {
            ...formData,
            search: JSON.stringify(formData.search),
            sort: JSON.stringify(formData.sort)
        }
        
        const response = await ApiService.get('/cms/expires', data);
        
        setTotal(response.data.total);
        setRows(response.data.rows);

        setLoading(false);
    }

    useEffect(() => {
        getRows();
    }, [formData]);

    const onAllItemSelected = (selected) => {
        setRows(rows.map(row => ({
            ...row,
            selected: selected
        })))
    }
    const onPageChanged = (pageNum) => {
        setFormData({
            ...formData,
            pageNum
        })
    }
    const onPerPageChanged = (opt) => {
        setFormData({
            ...formData,
            pageNum: 1,
            perPage: opt.value
        })
    }
    const onRowSelected = (e, row) => {
        setRows(rows.map(r => {
            if(r.id != row.id) return r;
            return {
                ...r,
                selected: e.target.checked
            }
        }))
    }
    const handleBulkAction = (bulkData) => {
        if(!bulkData.action) return;
        const selRows = rows?.filter(row => row.selected);
        if(selRows?.length > 0) {
            if(window.confirm('Are you sure to do this action?') == false) return;
            
            setBulkActioning(true);
            const data = {
                ...bulkData,
                ids: selRows.map(r => r.id)
            }
            ApiService.post(`/cms/bulkaction`, data).then(() => {
                getRows();
            })
            .finally(() => {
                setBulkActioning(false);
            })
        }
    }
    const handleSearch = async (search) => {
        setFormData({
            ...formData,
            pageNum: 1,
            search: search
        })
    }
    const handleSort = (sort) => {
        setFormData({
            ...formData,
            pageNum: 1,
            sort: sort
        })
    }

    const onActiveChange = (e, row) => {
        const data = {
            id: row.id,
            active: e.target.checked
        }

        const message = e.target.checked ? "Are you sure to activate?" : "Are you sure to deactivate?";
        if(window.confirm(message) == false) return;
        
        ApiService.post(`/cms/activate/${row.type}`, data).then(() => {
            getRows();
        })
    }
    const gotoEdit = (row) => {
        navigate(`/cms/homepage/${row.type}/edit/${row.id}`);
    }
    const handleCopy = (row) => {
        navigate(`/cms/homepage/${row.type}/copy/${row.id}`);
    }
    const handleDelete = (row) => {
        if(window.confirm("Are you sure to delete?") == false) return;
        ApiService.delete(`/cms/${row.id}`).then(() => {
            getRows();
        })
    }

    const renderTbodyTr = (row, rowIndex) => {
        const now = LondonDate(new Date());
        const start_date = LondonDate(row.start_date);
        const end_date = LondonDate(row.end_date);
        let className = "cursor-pointer ";

        if(row.active == "1") {
            if(end_date < now) className += "expired";
            if(start_date > now) className += "not-started";
            if(start_date < now && now < end_date) className += "active";
        } else {
            className += "inactive";
        }

        return (
            <tr key={rowIndex} className={`${className}`}>
                { columns.map((col, colIndex) => {
                    const el = renderTdCell(row, col.data ?? col.name, rowIndex, colIndex);
                    if(el) {
                        return <td key={colIndex}>{el}</td>
                    } else {
                        return <td key={colIndex}>{row[col.name]}</td>
                    }
                })}
            </tr>
        )
    }

    const renderTdCell = (row, colname, rowIndex, colIndex) => {
        switch(colname) {
            case 'select':
                return <div className="d-flex align-items-center"> 
                    <MDBCheckbox name='' checked={row.selected ?? false} onChange={e => onRowSelected(e, row)} />
                    <span className="mt-1">{row.id}</span>
                </div>
            case 'start_date':
                return <div className="cursor-pointer" onClick={e=>gotoEdit(row)}>
                    <Moment format="DD/MM/YYYY HH:mm::ss">{LondonDate(row.start_date)}</Moment>
                </div>
            case 'end_date':
                return <div className="cursor-pointer" onClick={e=>gotoEdit(row)}>
                    <Moment format="DD/MM/YYYY HH:mm:ss">{LondonDate(row.end_date)}</Moment>
                </div>
            case 'active':
                return <MDBCheckbox checked={row.active == "1"} onChange={e=>onActiveChange(e, row)} />
            case 'action':
                return <div className="d-flex justify-content-end">
                <MDBBtn color="none" tag="a" onClick={() => gotoEdit(row)} title="Edit Content">
                    <MDBIcon fas icon="pencil-alt" size="lg" color="warning" />
                </MDBBtn>
                <MDBBtn color="none" tag="a" title="Copy Content" onClick={() => handleCopy(row)}>
                    <MDBIcon far icon='copy' size="lg" className="ms-2" color="warning" />
                </MDBBtn>
                <MDBBtn color="none" tag="a" onClick={()=>handleDelete(row)} title="Delete Content">
                    <MDBIcon far icon="trash-alt" size="lg" color="danger" className="ms-2" />
                </MDBBtn>
            </div>
            default:
                return <div className="cursor-pointer" onClick={e=>gotoEdit(row)}>{row[colname]}</div>;
            
        }        
    }

    const columns = [
        {name: 'select', title: 'ID', headerStyle:{width:50, paddingLeft:30}, search: {
            enable: true, type: 'check', onChange: onAllItemSelected
        }},
        {name: 'type', title: 'Type', sortable: true, search: {
            enable: true, type: 'select', ops:[{value:'=', label: '='}], options:cmsTypeOptions
        }},
        {name: 'start_date', title: 'Start Date', headerStyle:{width:250}, sortable: true, search: {
            enable: true, type: 'date', ops:[{value: '', label: 'All'}, {value: '<', label:'<'}, {value: '>=', label: '>='}]
        }},
        {name: 'end_date', title: 'End Date', headerStyle:{width:250}, sortable: true, search: {
            enable: true, type: 'date', ops:[{value: '', label: 'All'}, {value: '<', label:'<'}, {value: '>=', label: '>='}]
        }},
        {name: 'internal_name', title: 'Internal Name', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {data: 'organization', name: 'epos_organizations.name', title: 'Organization', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'branches', title: 'Branches', search: {
            enable: true, type: 'text', ops:[{value: 'like', label: 'Like'}]
        }},
        {name: 'sequence', title: 'Sequence', headerStyle:{width:80}, sortable: true},
        {name: 'dwell_time', title: 'Dwell', headerStyle: {width: 100}, search: {
            enable: true, type: 'number', ops: [{value: '=', label: '='}]
        }},
        {name: 'editor', title: 'Editor'},
        {name: 'active', title: 'Active', headerStyle:{width:100}, sortable: true, search: {
            enable: true, type: 'select', ops:[{value:'=', label: '='}], options:[{value: '', label: 'All'}, {value: '1', label: 'Active'}, {value: '0', label: 'Deactive'}]
        }},
        {name: 'action', title: 'Action', headerClassName: "d-flex justify-content-end"}
    ];
    return (
    <div className="expire-preview">
        <div className="d-flex align-items-center me-1 mt-4">
            <div className="flex-fluid d-flex align-items-center ps-2">
                <label>Per Page:</label>
                <div className="ms-2" style={{width:100}}>
                    <Select 
                        options={perPageOptions} 
                        value={perPageOptions.find(opt=>opt.value == formData.perPage)} 
                        onChange={onPerPageChanged}
                    />
                </div>
                <label className="ms-4">
                    Found 
                    <span className='fw-bold mx-2' style={{color: '#333'}}>{total}</span> 
                    Matching Results.
                </label>
            </div>

            <div className="d-flex align-items-center">
                <BulkActionPanel 
                    bulkActions={[
                        BulkActions.Activate,
                        BulkActions.Deactivate,
                        BulkActions.Delete,
                        BulkActions.DwellTime,
                        BulkActions.StartDate,
                        BulkActions.EndDate
                    ]}
                    handleBulkAction={handleBulkAction} 
                    bulkActioning={bulkActioning} 
                />
            </div>
        </div>

        <div className="mt-3">
            <AdminTable
                columns={columns}
                rows={rows} 
                renderTbodyTr={renderTbodyTr} 
                handleSearch={handleSearch} 
                handleSort={handleSort}
                search={formData.search} 
                sort={formData.sort}
            />
        </div>

        <div className="flex-fluid d-flex justify-content-center mt-4">
            <Paginator curPage={formData.pageNum} total={total} perPage={formData.perPage} onPageChanged={onPageChanged} />
        </div>

        <LoadingIndicator show={loading} />
    </div>
    )
});

export default ExpirePreview;